import styled from "@emotion/styled"
import { css } from "@emotion/react"

export const EllipsisCSS = css`
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledEllipsis = styled.div`
  ${EllipsisCSS}
`
